<template>
  <el-tabs type="border-card" v-model="card_index">
    <el-tab-pane label="系数递增" name="ratio1">
      <div class="ratio-1">
        从第<input type="number" class="number-input" v-model="from_data1.start_floor" />层到<input type="number" class="number-input" v-model="from_data1.end_floor" />层，系数从<input type="number" class="number-input" v-model="from_data1.start_use_floor" />层开始每隔<input type="number" class="number-input" v-model="from_data1.floor_ratio" />层递增<input type="number" class="number-input" v-model="from_data1.ratio" />。
      </div>
    </el-tab-pane>
    <el-tab-pane label="批量系数" name="ratio2">
      <div class="ratio-2">
        <el-button @click="addRatio">添加</el-button>
        <el-table
          :data="tableData"
          border
          style="width: 100%" height="50vh">
          <el-table-column
            prop="start_floor"
            label="开始楼层"
            width="180">
            <template slot-scope="scope">
              <input type="number" class="number-input" v-model="scope.row.start_floor" />
            </template>
          </el-table-column>
          <el-table-column
            prop="end_floor"
            label="结束楼层"
            width="180">
            <template slot-scope="scope">
              <input type="number" class="number-input" v-model="scope.row.end_floor" />
            </template>
          </el-table-column>
          <el-table-column
            prop="ratio"
            label="系数"
            width="180">
            <template slot-scope="scope">
              <input type="number" class="number-input" v-model="scope.row.ratio" />
            </template>
          </el-table-column>
          <el-table-column
            prop="customer_name"
            label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-view" @click="deleteRatio(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "FloorCompute",
  data(){
    return{
      card_index:"ratio1",
      from_data1:{
        start_floor:1,
        end_floor:5,
        start_use_floor:1,
        floor_ratio:2,
        ratio:0.5
      },
      tableData:[]
    }
  },
  methods:{
    deleteRatio(index){
      const that=this;
      let tableData=ERP.reJson(that.tableData);
      tableData.splice(index,1);
      that.tableData=tableData;
    },
    addRatio(){
      let len=this.tableData.length
      this.tableData.push({
        start_floor:1,
        end_floor:5,
        ratio:len*0.5
      })
    },
    getData(){
      let obj={};
      obj.type=this.card_index;
      if(obj.type==='ratio1'){
        let _obj=ERP.reJson(this.from_data1)
        let keys=Object.keys(_obj);
        keys.map(ret=>{
          _obj[ret]=(_obj[ret]||0)*1;
        })
        obj.data=ERP.reJson(_obj);
      }else {
        let _list=ERP.reJson(this.tableData)
        _list.map(ret=>{
          ret.start_floor=ret.start_floor*1;
          ret.end_floor=ret.end_floor*1;
          ret.ratio=ret.ratio*1;
        })
        obj.data=ERP.reJson(_list);
      }
      return obj;
    }
  }
}
</script>

<style lang="scss" scoped>
.ratio-1{
  //height: 500px;
  display: flex;
  flex-direction: row;

  .number-input{
    background-color: #ffe5d5;
    color: black;
    width: 100px;
    text-align: center;
  }
}
.ratio-2{
  //height: 500px;
  .number-input{
    background-color: #ffe5d5;
    color: black;
    width: 100%;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/apportion/FloorCompute.vue